import React from 'react';
import Carousel from '../carousel/SimpleSlider';

const Dashboard = () => {
    return (
        <div>
            <Carousel />
        </div>
    );
};

export default Dashboard;